import React from "react";
import { useParams } from "react-router-dom";
import ModulePage from "../../shared-ui/ModulePage";
import TaskDetailPage from "./TaskDetailPage";
import "../../shared-ui/crane-tokens.css";

export default function StitchTaskDetailPage() {
  const { taskId } = useParams();
  return (
    <ModulePage
      crumbs={["Operations", "ZTask", "Task detail"]}
      title={taskId ? `Task #${taskId}` : "Task detail"}
      description="Full task record, history, and actions from the live backend."
    >
      <TaskDetailPage />
    </ModulePage>
  );
}
